import CategoriesNav from "gatsby-theme-dettol/src/components/common/CategoriesNav/CategoriesNav"

import "./CategoriesNavOverride.scss"

export default CategoriesNav